"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriceSchemaProperties = exports.PriceSchema = exports.PriceRecurring = exports.PriceInterval = void 0;
const zod_1 = require("zod");
const base_schema_1 = require("./base-schema");
const schema_properties_interface_1 = require("./schema-properties-interface");
exports.PriceInterval = zod_1.z.enum(["month", "week", "year", "day"]);
exports.PriceRecurring = zod_1.z.object({
    interval: exports.PriceInterval,
    intervalCount: zod_1.z.number(),
});
exports.PriceSchema = base_schema_1.BaseSchema.extend({
    amount: zod_1.z.number(),
    active: zod_1.z.boolean(),
    tierId: zod_1.z.string(),
    recurring: exports.PriceRecurring,
    order: zod_1.z.number(),
    priceInfo: zod_1.z.string().optional(),
});
exports.PriceSchemaProperties = {
    collectionName: "prices",
    deleteMode: schema_properties_interface_1.DeleteMode.Soft,
};
//# sourceMappingURL=price-schema.js.map